export const Card = ({ children, className = '', ...props }) => (
  <section
    className={`rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel)] shadow-sm ${className}`}
    {...props}
  >
    {children}
  </section>
);
